
  import {defineComponent, PropType} from "vue";
  import {CompanyLocationV2Dto} from "@/service/CompanyLocationService";
  import InventoriesCompanyLocationsListTile from "./InventoriesCompanyLocationsListTile.vue";

  export default defineComponent({
    name: "InventoriesCompanyLocationsList",
    components: {
      InventoriesCompanyLocationsListTile
    },
    props: {
      companyLocations: {
        type: Array as PropType<CompanyLocationV2Dto[]>,
        default: () => new Array<CompanyLocationV2Dto>()
      }
    },
    setup (props, context) {
      const openCompanyLocationDialog = (companyLocation: CompanyLocationV2Dto) => {
        context.emit("openCompanyLocationDialog", companyLocation);
      };

      return {
        openCompanyLocationDialog
      };
    }
  });
